export class Lead {
    constructor(firstname = "", lastname = "", email = "", firm = "", zip = "", sessionid = "", landingpage = "", filename = "", source = "", resource = "", workspaceid = "", campaignid = "", utmsource = "", utmmedium = "", utmcampaign = "", utmterm = "", utmcontent = "", disclosure = true, createdby = "0") {
        this.firstname = firstname;
        this.lastname = lastname;
        this.email = email;
        this.firm = firm;
        this.zip = zip;
        this.sessionid = sessionid;
        this.landingpage = landingpage;
        this.filename = filename;
        this.source = source;
        this.resource = resource;
        this.workspaceid = workspaceid;
        this.campaignid = campaignid;
        this.utmsource = utmsource;
        this.utmmedium = utmmedium;
        this.utmcampaign = utmcampaign;
        this.utmterm = utmterm;
        this.utmcontent = utmcontent;
        this.disclosure = disclosure;
        this.createdby = createdby;
    }
}
